import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ContentBlockForm from '../ContentBlockForm/ContentBlockForm';
import './ContentBlockModal.css';

const ContentBlockModal = ({
  onClose,
  isOpen,
  className,
  type,
  contentBlock,
  imageBasePath,
  sectionIndex,
  contentBlockIndex
}) => (
  <Modal isOpen={isOpen} toggle={onClose} className={className}>
    <ModalHeader>
      {type === 'edit' ? <span>Edit</span> : <span>Add new</span>} content block
    </ModalHeader>
    <ModalBody>
      <ContentBlockForm
        onClose={onClose}
        data={contentBlock}
        type={type}
        imageBasePath={imageBasePath}
        sectionIndex={sectionIndex}
        contentBlockIndex={contentBlockIndex}
      />
    </ModalBody>
  </Modal>
);

export default ContentBlockModal;



// WEBPACK FOOTER //
// ./src/components/landingPage/ContentBlockModal/ContentBlockModal.js